import { render, staticRenderFns } from "./800_KSAT25-45-0900-video-Personalized_Attack_Methods.vue?vue&type=template&id=a0379c32&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports